<script>
    export let showForm = false;
    export let email = '';
    let message = '';

    const toggleForm = () => {
        showForm = !showForm;
    };

    const sendEmail = () => {
        // Here, you would handle the form submission (e.g., by calling an API or sending an email)
        alert(`Email: ${email}\nMessage: ${message}`);
        showForm = false;
        email = '';
        message = '';
    };
</script>

<style>
    .chat-icon {
        position: fixed;
        bottom: 20px;
        right: 20px;
        background-color: #ff00b7;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 24px;
        cursor: pointer;
        z-index: 10;
    }

    .chat-form {
        position: fixed;
        bottom: 100px;
        right: 20px;
        width: 300px;
        background-color: white;
        padding: 15px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
    }

    .chat-form input, .chat-form textarea {
        width: 100%;
        padding: 10px;
        margin-bottom: 10px;
        border: 1px solid #ccc;
        border-radius: 5px;
    }

    .chat-form button {
        width: 100%;
        background-color: #007bff;
        color: white;
        padding: 10px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
    }

    .chat-form button:hover {
        background-color: #0056b3;
    }
</style>

<!-- Chat Icon -->
<div class="chat-icon" on:click={toggleForm}>
    💬
</div>

<!-- Chat Form -->
{#if showForm}
    <div class="chat-form">
        <h4>Contact Us</h4>
        <input type="email" placeholder="Your email" bind:value={email} />
        <textarea rows="4" placeholder="Message" bind:value={message}></textarea>
        <button on:click={sendEmail}>Send</button>
    </div>
{/if}
